// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h3p88","section":"styles_section__tB-UV"};